export default "__VITE_ASSET__e0a86e4e__"